import { RobotoPrincipalUnderlineLink } from "@/shared/components/principal";
import {
  ICellRendererParams,
  renderDashOr,
} from "@/shared/foundation/primitives/Table";

/**
 * A single shared definition so every resource table renders principals
 * identically.
 */
export const renderPrincipal = renderDashOr((params: ICellRendererParams) => (
  <RobotoPrincipalUnderlineLink principal={params.value as string} />
));

/**
 * Widen a bare email into the `type:id` principal {@link renderPrincipal}
 * reads.
 *
 * Most resources record their author as a qualified principal, but some --
 * triggers and agents among them -- store the caller's email alone. An
 * unqualified value still renders its text, but silently loses its link to
 * the user's page, so qualify it at the column rather than downgrading the
 * cell.
 */
export function qualifyPrincipal(principal: string | undefined): string {
  if (!principal) {
    return "";
  }
  return principal.includes(":") ? principal : `user:${principal}`;
}
